import type React from 'react';

import { OverflowContainer } from 'overflwn';
import { useTranslation } from 'react-i18next';

import { TextOverflow } from '../../../../../../components/TextOverflow';
import type { Company } from '../../../../../../domain/company';
import type { IntentSignal as IntentSignalType, SignalType } from '../../../../../../domain/signal';
import { useDispatchTrackEventWithLocation } from '../../../../../../services/tracking/hooks/useDispatchTrackEventWithLocation';
import { SignalHeader } from '../../SignalHeader';
import { StyledSignalItem, StyledSignalTitleContainer } from '../../styles';
import { Tag } from '../Tag/Tag';

import { StyledIntentButton, StyledIntentTagsContainer } from './styles';

type Props = {
  signal: IntentSignalType;
  company: Company;
};

export const IntentSignal: React.FC<Props> = ({ signal, company }) => {
  const { t } = useTranslation();
  const dispatchTrackEventWithLocation = useDispatchTrackEventWithLocation();

  const title = t('company.signals.intent.title', {
    companyName: company.name ?? company.domain,
    topicsAmount: signal.events.length,
  });

  const handleAllSignalsClick = () => {
    dispatchTrackEventWithLocation('signals', 'open signals in platform', 'see all topics');
    window.open(`https://pro.similarweb.com/#/sales/account-overview/${company.domain}/signals`, '_blank');
  };

  return (
    <StyledSignalItem>
      <SignalHeader type={signal.type as SignalType} eventHappenedDaysAgo={signal.eventHappenedDaysAgo} />
      <StyledSignalTitleContainer tooltipMaxWidth="99%">
        <TextOverflow text={title} />
      </StyledSignalTitleContainer>
      <StyledIntentTagsContainer>
        <OverflowContainer
          renderHiddenElements={() => (
            <StyledIntentButton variant="flat" onClick={handleAllSignalsClick}>
              {t('company.signals.intent.button')}
            </StyledIntentButton>
          )}
          gap={4}
        >
          {signal.events.map((event) => (
            <Tag value={event.topic} key={event.topic} />
          ))}
        </OverflowContainer>
      </StyledIntentTagsContainer>
    </StyledSignalItem>
  );
};
